import React from 'react';

import classNames from 'classnames';
import {useFormContext, useWatch} from 'react-hook-form';

import {useFeature} from 'components/feature';
import {AddressFormItemType, AddressFormType} from 'desktop/types/addressType';
import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';
import {useGetRegions} from 'hooks/location/location';

import {CustomerType} from 'hostApplicationStoreType';
import {getDeliveryFormStructure} from 'libs/getDeliveryFormStructure/getDeliveryFormStructure';

import {DeliveryFormField} from '../deliveryFormField/deliveryFormField';

import s from './deliveryFormFields.scss';

type PropsType = {
    target: 'shippingAddress' | 'billingAddress';
};

/**
 * Delivery form fields for checkout
 * @param {ProductType} props - props component
 * @returns {ReactElement} component
 */
export const DeliveryFormFields: React.FC<PropsType> = ({target}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const customer = useGetCustomerData() as CustomerType;
    const {control} = useFormContext<AddressFormType>();
    const countryValue = useWatch({control, name: `${target}.country`});
    const {regions = {}} = useGetRegions(countryValue);

    const structure = getDeliveryFormStructure(regions, customer, countryValue);

    return (
        <div className={classNames(s.form, {[s.formFacelift]: isFacelift})}>
            {Object.entries(structure).map(([key, field]) => (
                <div className={classNames(s.field, field.className)} key={key}>
                    <DeliveryFormField
                        countryValue={countryValue}
                        field={field}
                        fieldKey={key as keyof AddressFormItemType}
                        target={target}
                    />
                </div>
            ))}
        </div>
    );
};
